// extracted by mini-css-extract-plugin
export var footer = "_p0-5";
export var fulfillmentInput = "_p0-0";
export var shipDateInput = "_p0-1";
export var shipmentModal = "_p0-2";
export var shipmentModalContent = "_p0-3";
export var tableContainer = "_p0-4";